import { observer, use$ } from '@legendapp/state/react';
import { Stack, Text } from '@mantine/core';
import NumberFlow from '@number-flow/react';
import Decimal from 'decimal.js';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { configurationState$ } from '../../state';
import { walletState$ } from '../../state/wallet.state';
import { FreeBetsInfo } from '../FreeBetsInfo';

export const AccountBalance = observer(() => {
  const { t } = useTranslation();

  const balance = use$(walletState$.balance);
  const currency = use$(configurationState$.currency);
  const decimalScale = use$(configurationState$.decimalScale);

  const formattedBalance = useMemo(() => {
    return new Decimal(balance)
      .toDecimalPlaces(decimalScale, Decimal.ROUND_DOWN)
      .toNumber();
  }, [balance, decimalScale]);

  return (
    <Stack
      bg={{
        base: 'rgba(41, 41, 51, 0.8)',
        xl: 'rgba(41, 41, 51, 0.5)',
      }}
      data-test-id="account-balance"
      gap={2}
      miw={110}
      p={8}
      style={{
        borderRadius: 8,
      }}
    >
      <Text data-test-id="balance-label" fw={500} inline size="xs" ta="right">
        {t('common.balance')}
      </Text>

      <Text
        c="#FFFF49"
        data-balance={balance}
        data-test-id="balance-value"
        fw={600}
        size="md"
        style={{ fontVariantNumeric: 'tabular-nums' }}
        ta="right"
      >
        <NumberFlow
          animated={true}
          format={{
            minimumFractionDigits: decimalScale,
            maximumFractionDigits: decimalScale,
          }}
          locales="en-u-nu-latn"
          respectMotionPreference={true}
          suffix={` ${currency}`}
          value={formattedBalance}
        />
      </Text>

      <FreeBetsInfo />
    </Stack>
  );
});
